// Helpers puros del modelo de acceso por membresias (sin Supabase, testeables).
export const isAllowedFromOrgs = (orgs, isPlatformAdmin) =>
  !!isPlatformAdmin || (Array.isArray(orgs) && orgs.length >= 1);

export const resolveActiveOrg = (orgs, overrideId) => {
  if (!Array.isArray(orgs) || orgs.length === 0) return null;
  if (overrideId) {
    const match = orgs.find((o) => o.org_id === overrideId);
    if (match) return match;
  }
  return orgs.find((o) => o.es_principal) || orgs[0];
};

// ¿Es admin de ESTA org por su propia membresia? Un platform admin que entra a un club ajeno
// (override de org activa) no lo es. `rolEnOrgActiva` no sirve para preguntarlo: con un
// override sin membresia, resolveActiveOrg cae a la principal y contesta por OTRA org.
export const esAdminPorMembresia = (orgs, orgId) =>
  !!orgId && Array.isArray(orgs) && orgs.some((o) => o.org_id === orgId && o.rol === 'admin');
